<template>
  <div class="mx-auto">
    <RegistrationForm></RegistrationForm>
  </div>
</template>

<script>
import RegistrationForm from "@/components/airbox/RegistrationForm.vue";

export default {
  name: "Newuser",
  components: {
    RegistrationForm,
  },
  data: () => ({
    tab: null,
  }),
};
</script>